export default [{
	path: 'exam',
	component: () => import('../../../views/platform/exam/home'),
	children: [{
			path: 'tip',
			component: () => import('../../../views/platform/exam/tip')
		}, {
			path: 'questions',
			component: () => import('../../../views/platform/exam/questions')
		}, {
			path: 'lookAnalysis',
			component: () => import('../../../views/platform/exam/lookAnalysis')
		}, 
		// {
		// 	path: '1_x_oldAge',
		// 	component: () => import('../../../views/platform/exam/software_template/1_x_oldAge')
		// },
		// {
		// 	path: 'view2020',
		// 	component: () => import('../../../views/platform/exam/software_template/view2020')
		// },
		// // 居家适老化
		// {
		// 	path: 'homeDesign',
		// 	component: () => import('../../../views/platform/exam/software_template/homeDesign')
		// }
		{
			path: 'view3D',
			component: () => import('../../../views/platform/exam/software_template/view3D')
		},
	]
}]